import parseErrorMessage from 'utils/parseErrorMessage';

import { fetchIncidentsForGroup } from 'actions/roleActions';

import config from 'constants/apiConfig';
import axios from 'axios';
import {
  UPDATE_CURRENT_INCIDENT_REQUEST,
  UPDATE_CURRENT_INCIDENT_SUCCESS,
  UPDATE_CURRENT_INCIDENT_ERROR,
  CREATE_INCIDENT_REQUEST,
  CREATE_INCIDENT_SUCCESS,
  CREATE_INCIDENT_ERROR,
  UPDATE_INCIDENT_REQUEST,
  UPDATE_INCIDENT_SUCCESS,
  UPDATE_INCIDENT_ERROR,
  UPDATE_INCIDENT_GROUP_REQUEST,
  UPDATE_INCIDENT_GROUP_SUCCESS,
  UPDATE_INCIDENT_GROUP_ERROR,
  UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST,
  UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS,
  UPDATE_CURRENTLY_SELECTED_GROUP_ERROR,
  SET_CLONE_DEFAULTS_REQUEST,
  SET_CLONE_DEFAULTS_SUCCESS,
  SET_CLONE_DEFAULTS_ERROR,
  FETCH_CLONE_DEFAULTS_REQUEST,
  FETCH_CLONE_DEFAULTS_SUCCESS,
  FETCH_CLONE_DEFAULTS_ERROR,
  GET_ALL_USER_SCHEDULE,
  ADD_USER_SCHEDULE_REQUEST,
  ADD_USER_SCHEDULE_SUCCESS,
  ADD_USER_SCHEDULE_ERROR,
  DELETE_USER_SCHEDULE_REQUEST,
  DELETE_USER_SCHEDULE_SUCCESS,
  GET_ALL_USER_SCHEDULE_REQUEST,
  GET_ALL_USER_SCHEDULE_SUCCESS,
  GENERATE_SIGNED_URL_REQUEST,
  GENERATE_SIGNED_URL_SUCCESS,
} from 'constants/dice-action-types';

import {
  fetchIncidents,
  updateCurrentlySelected,
  fetchUserGroupsRolesIncidents,
} from './profileActions';

import { validateRBACPermissionForAction } from './validationActions';
import { toast } from 'react-toastify';
import { endLoading } from 'reducers/loading/loading.action';
import { noAutoClose } from 'assets/data/config';

function updateCurrentIncidentRequest() {
  return {
    type: UPDATE_CURRENT_INCIDENT_REQUEST,
  };
}

export const updateCurrentIncidentSuccess = (currentIncident) => ({
  type: UPDATE_CURRENT_INCIDENT_SUCCESS,
  payload: currentIncident,
});

function updateCurrentIncidentError(error) {
  const errorMessage =
    'updateCurrentIncidentError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPDATE_CURRENT_INCIDENT_ERROR,
  };
}

export function updateCurrentIncident(currentIncident) {
  return (dispatch) => {
    try {
      dispatch(updateCurrentIncidentRequest());
      dispatch(updateCurrentIncidentSuccess(currentIncident));
      return currentIncident;
    } catch (error) {
      dispatch(updateCurrentIncidentError(error));
    }
  };
}

export function updateCurrentIncidentById(incidentId) {
  return (dispatch, getState) => {
    const state = getState();
    const incidents = state.app.incidents;
    const foundIncident = incidents.find(
      (incident) => incident.id === incidentId
    );
    if (foundIncident) {
      dispatch(updateCurrentIncident(foundIncident));
    }
  };
}

function createIncidentRequest() {
  return {
    type: CREATE_INCIDENT_REQUEST,
  };
}

function createIncidentSuccess(incident) {
  return {
    type: CREATE_INCIDENT_SUCCESS,
    payload: incident,
  };
}

function createIncidentError(error) {
  const errorMessage =
    'Error Creating Incident:\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: CREATE_INCIDENT_ERROR,
  };
}

export const createIncident = ({
  name,
  group_guid,
  severity,
  incident_types,
}) => {
  return (dispatch, getState) => {
    dispatch(createIncidentRequest());

    const { user_guid } = getState().app.user;
    return axios(config.apiGateway.createIncident, {
      method: 'POST',
      data: JSON.stringify({
        user_guid: user_guid,
        name: name.trim(),
        group_guid,
        severity,
        incident_types,
        todo_remove_new_ics_feature_flag_on: true,
      }),
    })
      .then((response) => {
        const incident = response.data || {};
        dispatch(fetchIncidents());
        if (group_guid) {
          dispatch(fetchIncidentsForGroup(group_guid));
        }
        dispatch(createIncidentSuccess(incident));
        if (getState().app.currentlySelectedGroup.group_guid === group_guid) {
          dispatch(updateCurrentIncident(incident));
        }
        return incident;
      })
      .catch((error) => {
        // Handle exception where name exists
        if (
          error.response &&
          error.response.data &&
          error.response.data.ERROR &&
          error.response.data.ERROR === 'Incident Name Exists'
        ) {
          dispatch(
            createIncidentError({
              message: 'This Incident name is in use.  Please enter a new one.',
            })
          );
          dispatch(endLoading());
        } else {
          dispatch(createIncidentError(error));
        }
      })
      .finally((result) => {
        dispatch(endLoading());
        return result;
      });
  };
};

function updateIncidentRequest() {
  return {
    type: UPDATE_INCIDENT_REQUEST,
  };
}

function updateIncidentSuccess(incident) {
  return {
    type: UPDATE_INCIDENT_SUCCESS,
    payload: incident,
  };
}

function updateIncidentError(error) {
  const errorMessage =
    'updateIncidentError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPDATE_INCIDENT_ERROR,
  };
}

export const updateIncident = (
  updatedIncident,
  archived = false,
  isIncidentNameUpdated = false
) => {
  return (dispatch, getState) => {
    dispatch(updateIncidentRequest());
    const { user_guid } = getState().app.user;
    return axios(config.apiGateway.updateIncident, {
      method: 'POST',
      data: JSON.stringify({
        user_guid,
        incident: updatedIncident,
      }),
    })
      .then((response) => {
        if (archived && updatedIncident.teams_id) {
          toast.warning(
            'Incident has been archived but the existing team site is not deleted.'
          );
        }
        if (isIncidentNameUpdated && updatedIncident.teams_id) {
          toast.warning(
            'Incident has been renamed but the existing team site will not be renamed.'
          );
        }
        const incident = response.data || {};
        dispatch(updateIncidentSuccess(incident));
      })
      .catch((error) => {
        dispatch(updateIncidentError(error));
        dispatch(endLoading());
      });
  };
};

function updateIncidentGroupRequest() {
  return {
    type: UPDATE_INCIDENT_GROUP_REQUEST,
  };
}

const updateIncidentGroupSuccess = (payload) => ({
  type: UPDATE_INCIDENT_GROUP_SUCCESS,
  payload,
});

function updateIncidentGroupError(error) {
  const errorMessage =
    'updateIncidentGroupError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPDATE_INCIDENT_GROUP_ERROR,
  };
}

export const updateIncidentGroup = ({ incidentGuid, groupGuid }) => {
  return (dispatch, getState) => {
    const { user_guid } = getState().app.user;
    const group = getState().app.groups.find((g) => g.group_guid === groupGuid);
    dispatch(updateIncidentGroupRequest());
    return axios(config.apiGateway.updateIncidentGroup, {
      method: 'POST',
      data: JSON.stringify({
        incident_id: incidentGuid,
        group_guid: groupGuid,
        user_guid,
      }),
    })
      .then((response) => {
        dispatch(validateRBACPermissionForAction(groupGuid));
        dispatch(fetchUserGroupsRolesIncidents(user_guid));
        dispatch(updateCurrentlySelectedGroup(group));
        dispatch(updateIncidentGroupSuccess(response.data || {}));
      })
      .catch((error) => {
        dispatch(updateIncidentGroupError(error));
      });
  };
};

function updateCurrentlySelectedGroupRequest() {
  return {
    type: UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST,
  };
}

const updateCurrentlySelectedGroupSuccess = (currentlySelectedGroup) => ({
  type: UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS,
  payload: currentlySelectedGroup,
});

function updateCurrentlySelectedGroupError(error) {
  const errorMessage =
    'updateCurrentlySelectedGroupError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPDATE_CURRENTLY_SELECTED_GROUP_ERROR,
  };
}

export const updateCurrentlySelectedGroup = (group) => {
  return (dispatch) => {
    try {
      dispatch(updateCurrentlySelectedGroupRequest());
      dispatch(updateCurrentlySelectedGroupSuccess(group));
      dispatch(updateCurrentlySelected({ groupId: group.group_guid }));
      return group;
    } catch (error) {
      dispatch(updateCurrentlySelectedGroupError(error));
    }
  };
};

function setCloneDefaultsRequest() {
  return {
    type: SET_CLONE_DEFAULTS_REQUEST,
  };
}

function setCloneDefaultsSuccess(cloneDefaults) {
  return {
    type: SET_CLONE_DEFAULTS_SUCCESS,
    payload: cloneDefaults,
  };
}

function setCloneDefaultsError(error) {
  const errorMessage =
    'setCloneDefaultsError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: SET_CLONE_DEFAULTS_ERROR,
  };
}

export function setCloneDefaults(group_guid, incident_id) {
  return (dispatch) => {
    dispatch(setCloneDefaultsRequest());
    return axios(config.apiGateway.setCloneDefaults, {
      method: 'POST',
      data: JSON.stringify({
        group_guid,
        incident_id,
      }),
    })
      .then((response) => {
        const cloneDefaults = response.data || {};
        dispatch(setCloneDefaultsSuccess(cloneDefaults));
      })
      .catch((error) => {
        dispatch(setCloneDefaultsError(error));
      });
  };
}

function fetchCloneDefaultsRequest() {
  return {
    type: FETCH_CLONE_DEFAULTS_REQUEST,
  };
}

function fetchCloneDefaultsSuccess(cloneDefaults) {
  return {
    type: FETCH_CLONE_DEFAULTS_SUCCESS,
    payload: cloneDefaults,
  };
}

function fetchCloneDefaultsError(error) {
  const errorMessage =
    'fetchCloneDefaultsError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: FETCH_CLONE_DEFAULTS_ERROR,
  };
}

export function fetchCloneDefaults() {
  return (dispatch) => {
    dispatch(fetchCloneDefaultsRequest());
    return axios(config.apiGateway.fetchCloneDefaults, {
      method: 'POST',
    })
      .then((response) => {
        const cloneDefaults = response.data || {};
        dispatch(fetchCloneDefaultsSuccess(cloneDefaults));
      })
      .catch((error) => {
        dispatch(fetchCloneDefaultsError(error));
      });
  };
}

function addUserScheduleError(error) {
  const errorMessage =
    'addUserSchedule\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: ADD_USER_SCHEDULE_ERROR,
  };
}

function deleteUserScheduleError(error) {
  const errorMessage =
    'deleteUserSchedule\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return;
}

function fetchAllUserScheduleError(error) {
  const errorMessage =
    'getAllUserSchedule\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return;
}

export const addUserSchedule = (schedule) => {
  return (dispatch, getState) => {
    dispatch({ type: ADD_USER_SCHEDULE_REQUEST });
    const { group_guid } = getState().app.currentlySelectedGroup;
    return axios(config.apiGateway.addUserSchedule, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: group_guid,
        schedule: schedule,
      }),
    })
      .then(() => {
        dispatch({ type: ADD_USER_SCHEDULE_SUCCESS });
        dispatch(getAllUserSchedule());
      })
      .catch((error) => {
        dispatch(addUserScheduleError(error));
        dispatch(endLoading());
      });
  };
};

export const deleteUserSchedule = (schedule) => {
  return (dispatch, getState) => {
    dispatch({ type: DELETE_USER_SCHEDULE_REQUEST });
    const { group_guid } = getState().app.currentlySelectedGroup;
    return axios(config.apiGateway.deleteUserSchedule, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: group_guid,
        schedule: schedule,
      }),
    })
      .then(() => {
        dispatch({ type: DELETE_USER_SCHEDULE_SUCCESS });
        dispatch(getAllUserSchedule());
      })
      .catch((error) => {
        dispatch(deleteUserScheduleError(error));
      });
  };
};

export const getAllUserSchedule = (userGuid) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_ALL_USER_SCHEDULE_REQUEST });
    const { user_guid } = getState().app.user;
    const { group_guid } = getState().app.currentlySelectedGroup;
    return axios(config.apiGateway.getAllUserSchedule, {
      method: 'POST',
      data: JSON.stringify({
        user_guid: userGuid || user_guid,
        group_guid,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_ALL_USER_SCHEDULE_SUCCESS });
        dispatch({ type: GET_ALL_USER_SCHEDULE, payload: response.data });
      })
      .catch((error) => {
        dispatch(fetchAllUserScheduleError(error));
      });
  };
};

function generateSignedUrlError(error) {
  const errorMessage =
    'generateSignedURL\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return;
}

export const generateSignedUrl = (url) => {
  return (dispatch) => {
    dispatch({ type: GENERATE_SIGNED_URL_REQUEST });

    return axios
      .post(config.apiGateway.generateSignedUrl, {
        method: 'POST',
        data: JSON.stringify({
          url,
        }),
      })
      .then((response) => {
        const result = response.data || {};
        const { signedUrl } = result;
        dispatch({
          type: GENERATE_SIGNED_URL_SUCCESS,
          payload: signedUrl,
        });
        return signedUrl;
      })
      .catch((e) => {
        dispatch(generateSignedUrlError(e));
      });
  };
};
